import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

export default function withFlags(Component) {
  function WrappedComponent(props) {
    const flags = useFlags();
    return <Component {...props} flags={flags} />;
  }

  WrappedComponent.displayName = `withFlags(${Component.displayName || Component.name || 'Component'})`;
  return WrappedComponent;
}
